export default __webpack_public_path__ + "static/tisha-profile-a4f76e05d8bbf0b71c4555467e9f7944.jpg";